function isNumber(val) {
  return typeof val === 'number';
}

export default isNumber;
